import { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@design-system';

interface TooltipLabelProps {
  label: string;
  labelSuffix?: ReactNode;
  tooltip: ReactNode;
  className?: string;
}

export function TooltipLabel({ label, labelSuffix, tooltip, className }: TooltipLabelProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={`cursor-help border-b border-dotted border-gray-400 text-gray-700 ${className ?? ''}`}
        >
          {label}
          {labelSuffix}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-sm text-xs">{tooltip}</TooltipContent>
    </Tooltip>
  );
}
